import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import EmailTemplatesHome from './Index.vue';
import EmailEditorRoute from './builder/EmailEditorRoute.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'email_templates_index', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'email_templates_index',
          meta: {
            permissions: [...ROLES],
          },
          component: EmailTemplatesHome,
        },
      ],
    },
    // Construtor em tela cheia (fora do SettingsWrapper), como o das Páginas.
    {
      path: frontendURL(
        'accounts/:accountId/settings/email-templates/:templateId/editor'
      ),
      name: 'email_templates_builder',
      meta: {
        permissions: [...ROLES],
      },
      component: EmailEditorRoute,
    },
  ],
};
